<template>
    <form lpformnum="3" role="form" @submit.prevent="register">
        <email-input
            @clear="$emit('clearEmail')"
            :disabled="true"
            :value="email"
        ></email-input>
        <p class="text-info">
            <i class="fa fa-info-circle"></i> Please enter a memorable password. This will be used to manage your
            booking
        </p>
        <div class="form-group">
            <label for="password">Password</label>
            <password-input id="password" v-model="password"></password-input>
        </div>
        <div class="form-group">
            <label for="passwordConfirm">Confirm Password</label>
            <password-input
                :class="{'is-invalid': invalidPassword}"
                id="passwordConfirm"
                v-model="passwordConfirm"
            ></password-input>
            <div class="invalid-feedback" v-if="invalidPassword && bootstrap4">Passwords do not match.</div>
        </div>
        <terms-conditions
            :is-invalid="invalidTerms"
            :bootstrap4="bootstrap4"
            v-model="terms"
        ></terms-conditions>
        <submit-button
            :loading="loading"
            text="Create Account & Proceed"
        ></submit-button>
    </form>
</template>

<script>
import axios from "axios";

import EmailInput from "./Inputs/Email.vue";
import PasswordInput from "./Inputs/Password.vue";
import SubmitButton from "./SubmitButton.vue";
import TermsConditions from "./Inputs/TermsConditions.vue";

import loginResponse from "./mixins/loginResponse";

export default {
    name: 'Register',

    components: {
        EmailInput,
        PasswordInput,
        SubmitButton,
        TermsConditions,
    },

    mixins: {loginResponse},

    props: {
        email: {
            required: true,
            type: String,
        },
        redirect: {
            default: '',
            required: false,
            type: String,
        },
        theme: {
            required: true,
            type: String,
        },
        urlPrefix: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            invalidPassword: false,
            invalidTerms: false,
            loading: false,
            password: '',
            passwordConfirm: '',
            terms: false,
        }
    },

    computed: {
        bootstrap4() {
            return this.theme === 'bs4';
        },
        validPassword() {
            return this.password.length && this.password === this.passwordConfirm;
        },
    },

    methods: {
        async register() {
            this.loading = true;

            if (!this.validates()) {
                this.$emit('error');
                this.loading = false;

                return;
            }

            await axios
                .post(`${this.urlPrefix}/api/internal/users.json`, {
                    email: this.email,
                    password: this.password,
                    password_confirm: this.passwordConfirm,
                    tos: this.terms
                }, {
                    headers: {'Accept': 'application/vnd.api+json'}
                })
                .then(response => loginResponse(response, this))
                .catch(() => this.$emit('error'));

            this.loading = false;
        },
        validates() {
            Object.assign(this, {
                invalidPassword: !this.validPassword,
                invalidTerms: !this.terms,
            });

            return this.validPassword && this.terms;
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrSignup/Register.vue